import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { GetLocalStorage } from "./resource";
import { DASHBOARD, HOME } from "./routes";

const useAuth = () => {
  const data = GetLocalStorage?.("gida_token");

  if (data?.auth_token !== null) {
    return data?.auth_token;
  }
};

const ProtectedRoutes = () => {
  const isAuth = useAuth();
  return !isAuth ? <Navigate to={HOME} /> : <Outlet />;
};

const LoggedInRoute = () => {
  const isAuth = useAuth();
  return !isAuth ? <Outlet /> : <Navigate to={DASHBOARD} />;
};

export { ProtectedRoutes, useAuth, LoggedInRoute };
